var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"router"}},[(_vm.loading)?_c('div',{staticClass:"loading-wrapper"},[_c('updox-loading',{attrs:{"color":"#003462","size":"80px"}})],1):_c('div',[_c('h1',{staticClass:"not-needed"},[_vm._v("Just here for routing")])])])}
var staticRenderFns = []

export { render, staticRenderFns }